import { APICore } from "./apiCore";

const api = new APICore();

function getSubApi() {
  const baseUrl = "/subscriptions";
  

  return api.get(`${baseUrl}`, {});
}

function deleteSubApi(id: number) {
  const baseUrl = `/subscriptions/${id}`;
  return api.delete(`${baseUrl}`);
}

export { getSubApi, deleteSubApi };
